import { c as o, cB as i, cE as n, cM as r, insideModal as t, asModal as a } from "../../../_utils/cssr/index.js";
const c = o([i("dialog", `
 --n-icon-margin: var(--n-icon-margin-top) var(--n-icon-margin-right) var(--n-icon-margin-bottom) var(--n-icon-margin-left);
 word-break: break-word;
 line-height: var(--n-line-height);
 position: relative;
 background: var(--n-color);
 color: var(--n-text-color);
 box-sizing: border-box;
 margin: auto;
 border-radius: var(--n-border-radius);
 padding: var(--n-padding);
 transition: 
 border-color .3s var(--n-bezier),
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 `, [n("icon", {
  color: "var(--n-icon-color)"
}), r("bordered", {
  border: "var(--n-border)"
}), r("icon-top", [n("close", {
  margin: "var(--n-close-margin)"
}), n("icon", {
  margin: "var(--n-icon-margin)"
}), n("content", {
  textAlign: "center"
}), n("title", {
  justifyContent: "center"
}), n("action", {
  justifyContent: "center"
})]), r("icon-left", [n("icon", {
  margin: "var(--n-icon-margin)"
}), r("closable", [n("title", `
 padding-right: calc(var(--n-close-size) + 6px);
 `)])]), n("close", `
 position: absolute;
 right: 0;
 top: 0;
 margin: var(--n-close-margin);
 transition:
 background-color .3s var(--n-bezier),
 color .3s var(--n-bezier);
 z-index: 1;
 `), n("content", `
 font-size: var(--n-font-size);
 margin: var(--n-content-margin);
 position: relative;
 word-break: break-word;
 `, [r("last", "margin-bottom: 0;")]), n("action", `
 display: flex;
 justify-content: flex-end;
 `, [o("> *:not(:last-child)", `
 margin-right: var(--n-action-space);
 `)]), n("icon", `
 font-size: var(--n-icon-size);
 transition: color .3s var(--n-bezier);
 `), n("title", `
 transition: color .3s var(--n-bezier);
 display: flex;
 align-items: center;
 font-size: var(--n-title-font-size);
 font-weight: var(--n-title-font-weight);
 color: var(--n-title-text-color);
 `), i("dialog-icon-container", `
 display: flex;
 justify-content: center;
 `)]), t(i("dialog", `
 width: 446px;
 max-width: calc(100vw - 32px);
 `)), i("dialog", [a(`
 width: 446px;
 max-width: calc(100vw - 32px);
 `)])]);
export {
  c as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/naive-ui@2.42.0_vue@3.5.18/~/naive-ui/es/dialog/src/styles/index.cssr.js
// module id = 1635
// module chunks = 41